import React from 'react';

import { HashLink as Link } from 'react-router-hash-link';

import PropTypes from 'prop-types';
import cx from 'classnames';
import './cards.css';
import Button from '../button/button';
import Anchor from '../anchor/anchor';

const { pages } = require('../../data.json');

class Cards extends React.Component {
    render() {
        const { isOnMainPage } = this.props;
        let _pages = pages;
        if (isOnMainPage) {
            _pages = pages.slice(0, 7);
        }

        return (
            <div className="cards">
                <Anchor id="cards" />
                <div className="cards__pictures">
                    <img alt="" className="cards__picture-stars" src="./images/index/stars-2.svg" />
                    <img
                        alt=""
                        className="cards__picture-clouds"
                        src="./images/index/clouds-2.svg"
                    />
                    <img
                        alt=""
                        className="cards__picture-stars-1"
                        src="./images/cards/stars-1.svg"
                    />
                    <img alt="" className="cards__picture-cloud" src="./images/cards/cloud.svg" />
                    <img
                        alt=""
                        className="cards__picture-stars-2"
                        src="./images/cards/stars-2.svg"
                    />
                    <img
                        alt=""
                        className="cards__picture-clouds-2"
                        src="./images/cards/clouds.svg"
                    />
                    <div
                        className="cards__picture-icon"
                        style={{ backgroundImage: 'url(./images/index/emoji.svg)' }}
                    />
                    <div className="cards__title">Шедевры Русского музея</div>
                    <div className="cards__text">
                        выберите карточку и узнайте больше о картинах в нашей коллекции
                    </div>
                    <div className="blocks">
                        {_pages.map((element, index) => (
                            <Card
                                artist={element.name}
                                background={element.background}
                                className="cards__card"
                                image={element.smallImage}
                                key={element.name}
                                link={'/page/' + index}
                                paint={element.title}
                            />
                        ))}
                        {isOnMainPage ? (
                            <Card
                                artist="Все картины проекта"
                                buttonImage="./images/index/btn-next-yellow.png"
                                className="cards__card card_c6d2ff cards__card_last"
                                image="./images/index/hands.svg"
                                link="/cards"
                            />
                        ) : null}
                        {isOnMainPage ? null : (
                            <Button
                                className="cards__button"
                                isYellow
                                text="свернуть"
                                to="/index"
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

Cards.propTypes = {
    isOnMainPage: PropTypes.bool
};

Cards.defaultProps = {
    isOnMainPage: false
};

const Card = ({ artist, background, buttonImage, className, image, link, paint }) => {
    return (
        <Link
            className={cx('card', className, 'card_' + background.replace('#', ''))}
            to={link || '/page'}
        >
            <div className="card__background-wrapper">
                <div className="card__wrapper">
                    <div className="card__image-wrapper">
                        <img alt="artwork" className="card__image" src={image} />
                    </div>
                    <div className="card__title">{paint}</div>
                    <div className="card__name">{artist}</div>
                </div>
                <div
                    className="card__button"
                    style={{
                        backgroundImage: `url(${buttonImage || './images/page/btn-next.svg'})`
                    }}
                />
            </div>
        </Link>
    );
};

Card.propTypes = {
    artist: PropTypes.string,
    background: PropTypes.string,
    buttonImage: PropTypes.string,
    className: PropTypes.string,
    image: PropTypes.string,
    link: PropTypes.string,
    paint: PropTypes.string
};

Card.defaultProps = {
    background: 'default'
};

export default Cards;
